import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect } from "react";
import { useAuth } from "../../context/API_Client";

const ITEM_HEIGHT = 48;
export default function MoreOptionsForTable({
  options,
  data,
  handleActionValue,
  handleActionData,
  disableDelete,
  dataForUser,
  dataForRole,
  disableDeleteForActiveUser,
  operationPermissions,
}) {
  const { isAuthorizedPermission } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [disableDeleteOption, setDisableDeleteOption] = React.useState(false);
  const [disableDeleteOptionForUsers, setDisableDeleteOptionForUsers] =
    React.useState(false);
  const [optionsToDisplay, setOptionsToDisplay] = React.useState([]);
  const open = Boolean(anchorEl);
  const [optionValue, setOptionValue] = useState("");
  let userEmail = null;
  const loginUser = localStorage?.getItem("userDetails");
  const userObject = JSON.parse(loginUser);
  userEmail = userObject?.email;
  const isUserSame = userEmail == data.email

  useEffect(() => {
    const isDeleteUserAuthorized = isAuthorizedPermission(
      operationPermissions?.deleteUser
    );
    const isEditUserAuthorized = isAuthorizedPermission(
      operationPermissions?.updateUser
    );
    if (dataForUser) {
      setOptionsToDisplay((prevOptions) => {
        if (isEditUserAuthorized && !prevOptions.includes("Edit User")) {
          return [...prevOptions, "Edit User"];
        } else if (!isEditUserAuthorized && prevOptions.includes("Edit User")) {
          return prevOptions.filter((option) => option !== "Edit User");
        } else {
          return prevOptions;
        }
      });
      setOptionsToDisplay((prevOptions) => {
        if (isDeleteUserAuthorized && !prevOptions.includes("Delete")) {
          return [...prevOptions, "Delete"];
        } else if (!isDeleteUserAuthorized && prevOptions.includes("Delete")) {
          return prevOptions.filter((option) => option !== "Delete");
        } else {
          return prevOptions;
        }
      });
    }
  }, [dataForUser, isAuthorizedPermission]);
  useEffect(() => {
    const isDeleteRoleAuthorized = isAuthorizedPermission(
      operationPermissions?.deleteRole
    );
    const isEditRoleAuthorized = isAuthorizedPermission(
      operationPermissions?.updateRole
    );
    if (dataForRole) {
      setOptionsToDisplay((prevOptions) => {
        if (isEditRoleAuthorized && !prevOptions.includes("Edit Role")) {
          return [...prevOptions, "Edit Role"];
        } else if (!isEditRoleAuthorized && prevOptions.includes("Edit Role")) {
          return prevOptions.filter((option) => option !== "Edit Role");
        } else {
          return prevOptions;
        }
      });
      setOptionsToDisplay((prevOptions) => {
        if (isDeleteRoleAuthorized && !prevOptions.includes("Delete Role")) {
          return [...prevOptions, "Delete Role"];
        } else if (
          !isDeleteRoleAuthorized &&
          prevOptions.includes("Delete Role")
        ) {
          return prevOptions.filter((option) => option !== "Delete Role");
        } else {
          return prevOptions;
        }
      });
    }
  }, [dataForRole, isAuthorizedPermission]);

  useEffect(() => {
    if (options) {
      setOptionsToDisplay(options);
    }
  }, options);
  useEffect(() => {
    if (disableDelete) {
      if (
        data?.orgId &&
        data?.assignedUsers &&
        data?.assignedUsers?.length === 0
      ) {
        setDisableDeleteOption(false); // Enable "Delete" option
      } else {
        setDisableDeleteOption(true); // Disable "Delete" option
      }
    }
  }, [disableDelete, data?.orgId, data?.assignedUsers]);
  useEffect(() => {
    if (disableDeleteForActiveUser) {
      if (data?.email !== userEmail) {
        setDisableDeleteOptionForUsers(false); // Enable "Delete" option
      } else {
        setDisableDeleteOptionForUsers(true); // Disable "Delete" option
      }
    }
  }, [disableDeleteForActiveUser, data]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseMenuItem = (option) => {
    setOptionValue(option);
    setAnchorEl(null);
    handleActionValue(option);
    handleActionData(data);
  };

  useEffect(() => {
    if (data?.orgId === null) {
      setOptionsToDisplay((prevOptions) => {
        if (!prevOptions.includes("View Details")) {
          return [...prevOptions, "View Details"];
        } else {
          return prevOptions;
        }
      });
      setOptionsToDisplay((prevOptions) =>
        prevOptions.filter((option) => option !== "Edit Role")
      );
    }
  }, [data]);

  useEffect(() => {
    if (data?.status === "Pending" && data?.email !== userEmail) {
      setOptionsToDisplay((prevOptions) => {
        if (!prevOptions.includes("Resend Invite")) {
          return ["Resend Invite", ...prevOptions];
        } else {
          return prevOptions;
        }
      });
    } else if (data?.email === userEmail) {
      setOptionsToDisplay((prevOptions) => {
        const updatedOptions = prevOptions.filter(
          (option) => option !== "Resend Invite"
        );
        return updatedOptions;
      });
    }
  }, [data]);


  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        {optionsToDisplay?.map((option) => (
          <MenuItem
            key={option}
            selected={option === "Pyxis"}
            onClick={() => handleCloseMenuItem(option)}
            disabled={
              (option === "Delete Role" && disableDeleteOption) ||
              (option === "Delete" && disableDeleteOptionForUsers) ||
              (option === "Edit User" && isUserSame)
            }
            style={{
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: 400,
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
